module.exports = __webpack_public_path__ + "static/media/letterKnowledge-intro.0d4f991b.mp3";